import { render, staticRenderFns } from "./InvocationNetworkSelection.vue?vue&type=template&id=48b61f22&scoped=true"
import script from "./InvocationNetworkSelection.vue?vue&type=script&lang=ts"
export * from "./InvocationNetworkSelection.vue?vue&type=script&lang=ts"
import style0 from "./InvocationNetworkSelection.vue?vue&type=style&index=0&id=48b61f22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b61f22",
  null
  
)

export default component.exports